"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _InstanceData_instanceColors, _InstanceData_instanceMatrices;
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstanceData = void 0;
const AbstractTreeNodeData_1 = require("../AbstractTreeNodeData");
class InstanceData extends AbstractTreeNodeData_1.AbstractTreeNodeData {
    // #endregion Properties (2)
    // #region Constructors (1)
    /**
     * Creates a instanceMatrices data node.
     *
     * @param _data the data as key- value pairs
     * @param id the id
     */
    constructor(instanceMatrices = [], instanceColors = [], id, version) {
        super(id, version);
        // #region Properties (2)
        _InstanceData_instanceColors.set(this, []);
        _InstanceData_instanceMatrices.set(this, []);
        __classPrivateFieldSet(this, _InstanceData_instanceMatrices, instanceMatrices, "f");
        __classPrivateFieldSet(this, _InstanceData_instanceColors, instanceColors, "f");
    }
    // #endregion Constructors (1)
    // #region Public Getters And Setters (4)
    get instanceColors() {
        return __classPrivateFieldGet(this, _InstanceData_instanceColors, "f");
    }
    set instanceColors(value) {
        __classPrivateFieldSet(this, _InstanceData_instanceColors, value, "f");
    }
    get instanceMatrices() {
        return __classPrivateFieldGet(this, _InstanceData_instanceMatrices, "f");
    }
    set instanceMatrices(value) {
        __classPrivateFieldSet(this, _InstanceData_instanceMatrices, value, "f");
    }
    // #endregion Public Getters And Setters (4)
    // #region Public Methods (1)
    /**
     * Clones the scene graph data.
     */
    clone() {
        return new InstanceData(this.instanceMatrices, this.instanceColors, this.id, this.version);
    }
}
exports.InstanceData = InstanceData;
_InstanceData_instanceColors = new WeakMap(), _InstanceData_instanceMatrices = new WeakMap();
//# sourceMappingURL=InstanceData.js.map